import React from "react";
import { Button } from "@origin-digital/ods-core";
import { SvgIcon } from "@origin-digital/ods-icons";

interface EditButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
}

const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  children = "Update",
}) => {
  return (
    <Button
      variant="text"
      size="small"
      icon={
        <SvgIcon color="inherit">
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
        </SvgIcon>
      }
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default EditButton;
